import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=5a8e03d5&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports